
export class Event{
    id: EventId;
    object: any;

    constructor(id: EventId, obj: any) {
        this.id = id;
        this.object = obj;
    }
}

export enum EventId {
    DIALOG_OK,
    DIALOG_CANCEL,

    PLUS_KEY_PRESSED,

    QUERY_CRITERION_REMOVE,
    APPLY_QUERY,
    RESET_QUERY,
    ADD
}
